import { Button, ButtonProps } from "@mui/material";
import DosespotModal from "../DosespotModal";
import { useManageModal } from "src/hooks/useManageModal";
import { useGetSsoUrlQuery } from "src/api/services/ePrescribeApi";

interface Props {
  patientId: number;
  buttonProps?: ButtonProps;
  openModal?: boolean;
}

const DosespotButton = ({
  patientId,
  buttonProps = {},
  openModal = false,
}: Props) => {
  const { ssoLink, refetch } = useGetSsoUrlQuery(
    {
      patientId,
    },
    {
      selectFromResult: ({ data }) => {
        return { ssoLink: data?.link ?? "" };
      },
    },
  );

  const [open, { handleClose, handleOpen }] = useManageModal(openModal);

  return (
    <>
      <Button onClick={handleOpen} {...buttonProps}>
        Open Dosespot
      </Button>
      <DosespotModal
        open={open}
        link={ssoLink}
        onClose={handleClose}
        onRefresh={refetch}
      />
    </>
  );
};

export default DosespotButton;
